<template>
    <div class="bto-sb-container" :class="{'bto-sb-container-us' : isUS}">
        <!-- rows -->
        <row-component v-for="(row, index) in layoutData.widgets" :key="index">
            <!-- columns -->
            <col-component
                    v-bind:colcount="setColCount(cindex+1, layoutData.settings)"
                    v-bind:coldata="col"
                    :useSticky="col.settings.useSticky"
                    v-for="(col, cindex) in row.cols" :key="cindex">
                <!-- widgets for left and right columns
                     or middle colmun that doesn't have router widget -->
                <Fragment v-if="cindex !== middleColumn || childRouterIndex === -1">
                    <template v-for="(widget, windex) in col.widgets">
                      <col-copy-widget v-if="checkIfExactWidget(widget,'col-copy-widget')" :key="`ccw1-${windex}`" 
                        :defaultLayoutColIdx="cindex" 
                        v-bind="widget.compiledProps" />
                      <col-widget-component v-else v-bind:widget-data="widget" :key="`w1-${windex}`" />
                    </template>
                </Fragment>
                <!-- ======================================================= -->

                <!-- widgets in middle column before router ( including router widget ) -->
                <Fragment v-if="cindex === middleColumn">
                  <template v-for="(widget, windex) in getMiddleColumnWidgets(col)">
                    <col-copy-widget v-if="checkIfExactWidget(widget,'col-copy-widget')" :key="`ccw2-${windex}`" 
                        :defaultLayoutColIdx="cindex" 
                        v-bind="widget.compiledProps" />
                    <col-widget-component v-else v-bind:widget-data="widget" :key="`w2-${windex}`" />
                  </template>
                </Fragment>
                <!-- ======================================================= -->

                <!-- widgets in middle column after router -->
                <Fragment v-if="cindex === middleColumn && toggleAfterRouterWidgets">
                  <template v-for="(widget, windex) in getMiddleColumnWidgets(col,true)">
                    <col-copy-widget v-if="checkIfExactWidget(widget,'col-copy-widget')" :key="`ccw3-${windex}`" 
                        :defaultLayoutColIdx="cindex" 
                        v-bind="widget.compiledProps" />
                    <col-widget-component v-else v-bind:widget-data="widget" :key="`w3-${windex}`" />
                  </template>
                </Fragment>
                <!-- ======================================================= -->
            </col-component>
        </row-component>
        <toast-notifications/>
        <notfound-404 v-if="layoutData.length === 0"></notfound-404>
        <ModalsComponent />
    </div>
</template>

<script>
  import store from '../store';
  import ModalsComponent from './common/modals-component.vue';
  import ToastNotifications from './common/toast-notifications/toast-notifications';
  import { LAYOUT_NAME } from '../models/enums/layout-const';

  export default {
    name: 'WidgetLoaderComponent',
    data() {
      return {
        isUS: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
      };
    },
    computed: {
      /**
       * Get layout data
       */
      layoutData() {
        return store.getters.getDefaultLayoutData;
      },
      /**
       * Get middle column
       */
      middleColumn() {
        let middleColumn = 0;
        let layoutData = store.getters.getDefaultLayoutData;
        let isRev = typeof layoutData.settings.layoutSettings.reverseLayout !== 'undefined' ?
          layoutData.settings.layoutSettings.reverseLayout :
          false;
        // if isRev is true then middle column will be first one as layout is reversed
        if (layoutData.widgets[0].cols.length > 1 && !isRev) {
          middleColumn = 1;
        }
        return middleColumn;
      },
      /**
       * Check if we have a child router
       */
      childRouterIndex() {
        const layoutData = store.getters.getDefaultLayoutData;
        if (Object.keys(layoutData).length) {
          const middleColumn = this.getMiddleColumn(layoutData);
          const allWidgets = layoutData.widgets[0];
          const middleColWidgets = allWidgets.cols[middleColumn].widgets;
          for (let i = 0; i < middleColWidgets.length; i += 1) {
            if (middleColWidgets[i].widgetType === 'router-widget') {
              return i;
            }
          }
        }
        return -1;
      },
      /**
       * Shows hides widgets that are comming after router widget
       */
      toggleAfterRouterWidgets() {
        return store.state.LayoutModule.toggleAfterRouterWidgets;
      },
    },
    methods: {
      /**
       * Check if widget provided is specific widget
       * @param widget - Widget to check
       * @param widgetName - Vue registered component name
       */
      checkIfExactWidget(widget, widgetName) {
        return widget && widget.compiledProps && widget.compiledProps.is === widgetName;
      },
      /**
       * Get Widgets in middle column when router is present
       * @param col - Column to filter widgets from
       * @param {boolean} afterRouter - Flag weather to filter widgets before or after router
       */
      getMiddleColumnWidgets(col, afterRouter = false) {
        return col.widgets.filter((w, i) => {
          const widgetIsAfterRouter = i > this.childRouterIndex;
          const widgetIsPreRouter = i <= this.childRouterIndex;
          return this.childRouterIndex > -1 && (afterRouter ? widgetIsAfterRouter : widgetIsPreRouter);
        });
      },
      /**
       * Get middle column index
       * @param layout
       */
      getMiddleColumn(layout) {
        let isRev = typeof layout.settings.layoutSettings.reverseLayout !== 'undefined' ?
          layout.settings.layoutSettings.reverseLayout :
          false;
        let middleColumn = 0;
        if (layout.widgets[0].cols.length > 1) {
          middleColumn = 1;
        }
        // if layout is reversed, then we only have 2 columns of which first one is main column
        if (isRev) {
          middleColumn = 0;
        }
        return middleColumn;
      },
      /**
       * Set column count
       * @param index
       * @param settings
       * @returns {*}
       */
      setColCount(index, settings) {
        let isRev = typeof settings.layoutSettings.reverseLayout !== 'undefined'
          ? settings.layoutSettings.reverseLayout
          : false;
        if (isRev) {
          // if layout is reversed as we have only 2 columns
          // then reverse the index
          return index === 1 ? 2 : 1;
        }
        return index;
      },
    },
    components: {
      ModalsComponent,
      ToastNotifications
    }
  };
</script>
